export { MultilingualService } from "./MultilingualService";
export { DictionaryService } from "./DictionaryService";
export { translateText } from "./translate-text";
export { dictionaryEntriesField, switcherConfigField } from "./fields";
export { TranslationDashboardService } from "./dashboard/TranslationDashboardService";
export { createTranslationDashboardScreen } from "./dashboard/createTranslationDashboardScreen";
export type {
  SwitcherConfigItem,
  SwitcherEntry,
  DictionaryEntry,
  CollectionCoverage,
  TranslationAuditRow,
  TranslationSourceType,
} from "./types";
